import { faBarcode, faCheckCircle, faQrcode } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import Loader from 'src/components/loader';
import { BUREAU_BARCODE_FORMAT, LOCALSTORAGE_KEYS } from 'src/utils/constants';
import useLocalstorage from 'src/utils/useLocalStorage';

const ScanSuccessBanner = ({ isLoading, onScanAnother, disabled }) => {
  const [scanMode] = useLocalstorage(LOCALSTORAGE_KEYS.SCAN_MODE, BUREAU_BARCODE_FORMAT.QR);
  const scanIcon = scanMode === BUREAU_BARCODE_FORMAT.BARCODE ? faBarcode : faQrcode;

  if (isLoading) {
    return (
      <div className='scan-success-banner scan-success-banner--loading'>
        <Loader inline text='data' />
      </div>
    );
  }

  return (
    <div className='scan-success-banner'>
      <div className='scan-success-banner__header'>
        <FontAwesomeIcon
          icon={faCheckCircle}
          className='scan-success-banner__icon text-success'
          aria-hidden='true'
        />
        <p className='scan-success-banner__text mb-0'>Container scanned successfully</p>
      </div>
      <button
        type='button'
        className='btn btn-primary btn-block d-inline-flex align-items-center justify-content-center fs-mobile-18'
        disabled={disabled}
        onClick={onScanAnother}
      >
        <FontAwesomeIcon icon={scanIcon} className='mr-2' aria-hidden='true' />
        Scan another container
      </button>
    </div>
  );
};

ScanSuccessBanner.propTypes = {
  isLoading: PropTypes.bool,
  onScanAnother: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ScanSuccessBanner.defaultProps = {
  isLoading: false,
  disabled: false,
};

export default ScanSuccessBanner;
